import { cloneDeep } from 'lodash';
const SET_CAMPAIGN = 'SET_CAMPAIGN';

const initialState = null;

export default function reducer(state = cloneDeep(initialState), action) {
	switch (action.type) {
		case SET_CAMPAIGN:
			return action.payload;
		default:
			return state;
	}
}

export function setCampaign( campaign='' ){
	return{
		type: SET_CAMPAIGN,
		payload: campaign
	}
}



// WEBPACK FOOTER //
// ./src/modules/campaign.js